import { Spinner as FlowbiteSpinner } from 'flowbite-react';
import React from 'react';

export type SpinnerProps = React.ComponentProps<typeof FlowbiteSpinner>;

/**
 * App-wide Spinner component enforcing brand color.
 * - Defaults to size "md" if not provided
 * - Forces fill color to rgpd-blue-light while preserving other props
 */
const Spinner: React.FC<SpinnerProps> = ({ className, color, ...rest }) => {
  // We enforce the brand fill utility while allowing additional classes
  const mergedClassName = [
    'fill-rgpd-blue-light',
    className || '',
  ].join(' ').trim();

  return (
    <FlowbiteSpinner
      // Keep Flowbite color prop for shape/size mapping but override fill via className
      color={color}
      className={mergedClassName}
      {...rest}
    />
  );
};

export default Spinner;

